import Vue from 'vue'
import * as types from './mutation-types'
import * as globaltypes from '../../mutation-types'
import moment from 'moment'
import { isValueEmptyProto, cloneObject } from '../../../utils/utils';
import { wizardData } from '../../getters';

const mutation = {
  [types.SET_VERIFIED_QUOTE](state, newValue) {
    state.wizardData.verified = newValue
  },
  [types.SET_REMOTE_QUOTE_ID](state, newValue) {
    state.wizardData.remoteQuoteID = newValue
  },
  [types.SET_CURRENT_WIZARD_STEP](state, newValue) {
    state.wizardData.maxWizardStep = state.wizardData.maxWizardStep < newValue ? newValue : state.wizardData.maxWizardStep
    state.wizardData.currentWizardStep = newValue
    state.wizardData.quote.WizardStepTypeID = state.wizardData.quote.WizardStepTypeID > state.wizardData.currentWizardStep ? state.wizardData.quote.WizardStepTypeID : state.wizardData.currentWizardStep;
    state.wizardData.wizardStepStack.unshift(newValue);
  },
  [types.MOVE_WIZARD_BACK](state) {
    state.wizardData.wizardStepStack.shift();
    state.wizardData.currentWizardStep = state.wizardData.wizardStepStack[0];
  },
  [types.SET_NEXT_DISABLED](state, newValue) {
    state.wizardData.nextDisabled = newValue;
  },
  [types.SET_BACK_DISABLED](state, newValue) {
    state.wizardData.backDisabled = newValue;
  },
  [types.SET_CURRENT_STEP](state, newValue) {
    state.wizardData.currentstep = newValue
  },
  [types.SET_FLOW_CURRENT_STEP](state, data) {
    state.wizardData.steps[data.step - 1].flow_current_step = data.flow_step_value
  },
  [types.SET_CALLBACK_QUOTE](state) {
    state.new_quote.quote_info.callback = true;
  },
  [types.CHECK_VIN_INFORMATION](state, vin_info) {
    state.wizardData.quote_info.vin_api_info = vin_info
  },
  [types.SET_SELECTED_QUOTE](state, data) {
    if (data && Object.keys(data).length > 0 && data.constructor === Object) {
      var quote = {
        QuoteID: data.quoteID,
        CustomerID: data.customerID,
        ModifiedByUserID: 0,
        CreatedByUserID: data.createdByUserID,
        MarketID: data.marketID,
        OwnerByUserID: data.ownerByUserID,
        QuoteStatusTypeID: data.quoteStatusTypeID,
        QuoteOriginTypeID: data.quoteOriginTypeID,
        StateProofOfIdentificationID: data.stateProofOfIdentificationID == 0 ? null : data.stateProofOfIdentificationID,
        MarketDisplayName: data.market ? data.market.displayName : null,
        WizardStepTypeID: state.wizardData.quote.WizardStepTypeID,
        StateName: data.poiStateDisplayName ? data.poiStateDisplayName : null // State Name - Not Included
      };

      if (data.stateProofOfIdentification) {
        quote.ProofOfIdentificationTypeID = data.stateProofOfIdentification.proofOfIdentificationTypeID;
      }

      state.wizardData.quote = quote;

      if (data.callInformations) {
        state.wizardData.callInformations = data.callInformations; // This is new. It should be a collection.
      }

      state.wizardData.callInformation.QuoteID = data.quoteID; // Included as part of the callInformations collection, but should probably be set anew anyway..
      state.wizardData.callInformation.CallInformationID = 0;// data.callInformation.callInformationID; // Included as part of the callInformations collection, but should probably be set anew anyway..
      if (data.customer) {
        state.wizardData.customer.CustomerID = data.customer.customerID;
        state.wizardData.customer.FirstName = data.customer.firstName;
        state.wizardData.customer.LastName = data.customer.lastName;
        state.wizardData.customer.PrimaryPhone = data.customer.primaryPhone;
        state.wizardData.customer.SecondaryPhone = data.customer.secondaryPhone == 0 ? null : data.customer.secondaryPhone;
        state.wizardData.customer.EmailAddress = data.customer.emailAddress;
      }

      if (data.followups != null && data.followups[0] != null) {
        state.wizardData.followups = data.followups;
      }

      if (data.vehicles != null && data.vehicles[0] != null) {
        var vehicle = {
          VehicleID: data.vehicles[0].vehicleID,
          QuoteID: data.vehicles[0].quoteID,
          MakeID: data.vehicles[0].makeID,
          Make: "",
          ModelID: data.vehicles[0].modelID,
          Model: "",
          ModelYear: data.vehicles[0].modelYear,
          VIN: data.vehicles[0].vin,
          Operable: data.vehicles[0].operable,
          HasLien: state.wizardData.vehicle.HasLien,
          HasDamage: data.vehicles[0].conditionDescription != null,
          Condition: [],
          ConditionDescription: data.vehicles[0].conditionDescription,
          Enhancement: [],
          Components: data.vehicles[0].components,
          ProofOfOwnershipID: data.vehicles[0].proofOfOwnershipID,
          DocumentRepositoryID: 0,
          TitleNumber: data.vehicles[0].titleNumber,
          VehiclePriceAdjustment: data.vehicles[0].vehiclePriceAdjustment,
          IsActive: data.vehicles[0].isActive
        };

        state.wizardData.vehicle = vehicle;
        // makes seller price reactive in wizardData
        Vue.set(state.wizardData.vehicle, "SellerPrice", data.vehicles[0].sellerPrice)
        // WTF are these?
        state.wizardData.quote_info.make = data.vehicles[0].makeID;
        state.wizardData.quote_info.model = data.vehicles[0].modelID;
        state.wizardData.quote_info.year = data.vehicles[0].modelYear;

        if (data.vehicles[0].offers != null && data.vehicles[0].offers[0] != null) {
          state.wizardData.previousOffers = data.vehicles[0].offers.filter((o) => {
            return (o.OfferID != data.vehicles[0].currentOffer.offerID);
          });
          state.wizardData.offer.VehicleID = data.vehicles[0].currentOffer.vehicleID;
          state.wizardData.offer.OfferID = data.vehicles[0].currentOffer.offerID;
          state.wizardData.offer.SuggestedPrice = data.vehicles[0].currentOffer.suggestedPrice;
          state.wizardData.offer.OfferPrice = data.vehicles[0].currentOffer.offerPrice;
          state.wizardData.offer.OfferResponseTypeID = data.vehicles[0].currentOffer.offerResponseTypeID;
          state.wizardData.offer.DateCreated = data.vehicles[0].currentOffer.dateCreated;

        }

      }
      else {
        state.wizardData.vehicle.QuoteID = state.wizardData.quote.QuoteID;
      }

      if (data.quotePickupLocation != null) {
        // Make the quotePickupLocation object reactive
        Vue.set(state.wizardData.quotePickupLocation, '');
        state.wizardData.quotePickupLocation.RequestedDate = data.quotePickupLocation.requestedDate;
        state.wizardData.quotePickupLocation.StreetAddress1 = data.quotePickupLocation.streetAddress1;
        state.wizardData.quotePickupLocation.StreetAddress2 = data.quotePickupLocation.streetAddress2;
        state.wizardData.quotePickupLocation.City = data.quotePickupLocation.city;
        state.wizardData.quotePickupLocation.PickupLocationTypeID = data.quotePickupLocation.pickupLocationTypeID;
        state.wizardData.quotePickupLocation.QuoteID = data.quotePickupLocation.quoteID;
        state.wizardData.quotePickupLocation.SpecialInstructions = data.quotePickupLocation.specialInstructions;
        state.wizardData.quotePickupLocation.QuotePickupLocationID = data.quotePickupLocation.quotePickupLocationID;
        state.wizardData.quotePickupLocation.ZipCode = data.quotePickupLocation.zipCode;
        state.wizardData.quotePickupLocation.StateID = data.quotePickupLocation.stateID;
        state.wizardData.quote.StateID = data.quotePickupLocation.stateID;
        state.wizardData.quote.Abbreviation = data.quotePickupLocation.stateAbbreviation;
        state.wizardData.quote.StateName = data.quotePickupLocation.stateName; // State Name - Not Included
        // if pickupLocationTypeID is set - set vehicleRun with Operable value
        state.wizardData.vehicle.VehicleRun = (data.quotePickupLocation.pickupLocationTypeID == null) ? null : state.wizardData.vehicle.Operable;
      }

      if (state.wizardData.quote.QuoteOriginTypeID == 2) {
        state.wizardData.vehicle.VehicleRun = state.wizardData.vehicle.Operable;
      }

      if (data.quoteThirdPartyPartner != null) {
        state.wizardData.thirdParty.QuoteThirdPartyPartnerID = data.quoteThirdPartyPartner.quoteThirdPartyPartnerID
        state.wizardData.thirdParty.AssignmentNumber = data.quoteThirdPartyPartner.assignmentNumber
        state.wizardData.thirdParty.IsActive = data.quoteThirdPartyPartner.isActive
        state.wizardData.thirdParty.QuoteID = data.quoteThirdPartyPartner.quoteID
        state.wizardData.thirdParty.ThirdPartyPartnerID = data.quoteThirdPartyPartner.thirdPartyPartnerID
      }

      if (data.remoteQuoteMap != null) {
        state.wizardData.remoteQuoteID = data.remoteQuoteMap.remoteQuoteID;
      }

      // remove these? This should happen on wizard using the step-through logic.
      //state.wizardData.currentWizardStep = 1;
      //state.wizardData.steps[1].flow_current_step = 0;
      //state.wizardData.maxWizardStep = (state.wizardData.currentWizardStep > 2) ? 8 : 3;

      // unwind anything thats on the stack now.
      while (state.wizardData.wizardStepStack.length) {
        state.wizardData.wizardStepStack.shift();
      }

      // advance through the stack.
      if (data.wizardStepStack) {
        data.wizardStepStack.split(",").map(Number).reverse().forEach(newStep => {
          state.wizardData.maxWizardStep = state.wizardData.maxWizardStep < newStep ? newStep : state.wizardData.maxWizardStep
          state.wizardData.currentWizardStep = newStep
          state.wizardData.quote.WizardStepTypeID = state.wizardData.quote.WizardStepTypeID > state.wizardData.currentWizardStep ? state.wizardData.quote.WizardStepTypeID : state.wizardData.currentWizardStep;
          state.wizardData.wizardStepStack.unshift(newStep);
        });
      }


      // Pop save disposition.
      if (state.wizardData.wizardStepStack[0] == 7) {
        state.wizardData.wizardStepStack.shift();
        state.wizardData.currentWizardStep = state.wizardData.wizardStepStack[0];
      }
      // set next Button active by default
      state.wizardData.nextDisabled = false;
    }
  },
  [types.SET_QUOTE_LIST](state, data) {
    state.quote_list = data;
  },
  [types.SET_WEB_QUOTE_QUEUE](state, data) {
    state.web_quote_queue = data;
  },
  [types.LOAD_MODELS_BY_MAKE_AND_YEAR](state, models) {
    state.car_model_list = models
  },
  [types.UPDATE_QUOTE](state, quote) {
    let selectedQuote = state.quote_list.map((item) => {
      if (item.quoteID === quote.quoteID) {
        item = quote
        return item
      }
    })
  },
  [types.RESET_WIZARD](state, customer) {
    state.wizardData = null;
    state.wizardData = cloneObject(state.newWizardData);
    if (customer != null) { state.wizardData.customer = customer };
  },
  [types.DECLINE_INITIAL_QUOTE](state, offer) {
    //state.new_quote.quote_info.offer.push(offer)
    //state.new_quote.quote_info.first_decline = true;
    state.wizardData.quote_info.first_decline = true;
  },
  [types.UNSET_DECLINE_INITIAL_QUOTE](state) {
    //state.new_quote.quote_info.offer.pop();
    //state.new_quote.quote_info.first_decline = false;
    state.wizardData.quote_info.first_decline = false;
  },
  [types.DOBULE_DECLINE_INITIAL_QUOTE](state, offer) {
    //state.new_quote.quote_info.offer.push(offer)
    //state.new_quote.quote_info.second_decline = true;
    state.wizardData.quote_info.second_decline = true;
  },
  [types.SET_CALLBACK_QUOTE](state) {
    //state.new_quote.quote_info.callback = true;
    state.wizardData.quote_info.callback = true;
  },
  [types.UNSET_CALLBACK_QUOTE](state) {
    //state.new_quote.quote_info.callback = false;
    state.wizardData.quote_info.callback = false;
  },
  [types.SET_ACCEPTED_QUOTE](state, offer) {
    if (offer.success) {
      state.wizardData.offer.OfferID = offer.offer.offerID;
      state.wizardData.offer.DateCreated = offer.offer.dateCreated;
    }
  },
  [types.UNSET_ACCEPTED_QUOTE](state) {
    //state.new_quote.quote_info.offer.pop();
    //state.new_quote.quote_info.accepted = false;
    state.wizardData.quote_info.accepted = false;
  },
  [types.SET_QUOTE_STATUS](state, quotestatus) {
    state.wizardData.quote_info.status = quotestatus;
  },
  [types.SET_LIEN](state, lienStatus) {
    state.wizardData.vehicle.HasLien = lienStatus;
  },
  [types.SET_QUOTE_PICKUP_LOCATION](state, data) {
    if (data.status === 200) {
      state.wizardData.quotePickupLocation.QuotePickupLocationID = data.qplID;
      state.wizardData.quotePickupLocation.SpecialInstructions = data.qpl.SpecialInstructions;
      state.wizardData.quotePickupLocation.PickupLocationTypeID = data.qpl.PickupLocationTypeID;
      state.wizardData.quotePickupLocation.City = data.qpl.City;
      state.wizardData.quotePickupLocation.DisplayName = data.qpl.DisplayName;
      state.wizardData.quotePickupLocation.QuoteID = data.qpl.QuoteID;
      state.wizardData.quotePickupLocation.StateID = data.qpl.StateID;
      state.wizardData.quotePickupLocation.ZipCode = data.qpl.ZipCode;
      state.wizardData.quotePickupLocation.StreetAddress1 = data.qpl.StreetAddress1;
      state.wizardData.quotePickupLocation.StreetAddress2 = data.qpl.StreetAddress2;
    }
  },
  [types.SET_THIRD_PARTY](state, data) {
    state.wizardData.thirdParty.QuoteThirdPartyPartnerID = data.QuoteThirdPartyPartnerID
    state.wizardData.thirdParty.AssignmentNumber = data.thirdParty.AssignmentNumber
    state.wizardData.thirdParty.IsActive = data.thirdParty.IsActive
    state.wizardData.thirdParty.QuoteID = data.thirdParty.QuoteID
    state.wizardData.thirdParty.ThirdPartyPartnerID = data.thirdParty.ThirdPartyPartnerID
  },
  [types.SET_SELECTED_CALL_CODE_WIZARD](state, callcode) {
    state.wizardData.callInformation.CallCodeID = callcode;
  },
  [types.SET_SUGGESTED_OFFER](state, offer) {
    state.wizardData.offer.OfferID = offer.offerID;
    state.wizardData.offer.OfferPrice = offer.offerPrice;
    state.wizardData.offer.SuggestedPrice = offer.suggestedPrice;
    state.wizardData.offer.OfferResponseTypeID = offer.offerResponseTypeID;
    state.wizardData.offer.DateCreated = offer.dateCreated;
  },
  [types.SET_COMPONENTS_FOR_VEHICLE](state, data) {
    // state.wizardData.vehicle.ComponentSetID = data.componentSetID;
    // Check to see if the vehicle has components already (they were loaded or something.)
    // If that's the case, they are likely missing their other properties, because it is loading from Component instead of ComponentType
    if (state.wizardData.vehicle.Components != null && state.wizardData.vehicle.Components.length > 0) {
      // Assign display name/etc from the data out of the service call.
      state.wizardData.vehicle.Components.forEach(function (item, index) {
        data.forEach(function (typeItem, typeIndex) {
          if (typeItem.componentTypeID == item.componentTypeID) {
            item.makesVehicleIncomplete = typeItem.makesVehicleIncomplete;
            item.preventsBuying = typeItem.preventsBuying;
            item.displayName = typeItem.displayName;
          }
        });
      });
      // Make sure that the vehicle component list contains an entry for each type returned.
      data.forEach(function (item, index) {
        if (!state.wizardData.vehicle.Components.some(function (comp) { return comp.componentTypeID == item.componentTypeID; })) {
          item.isPresent = true;
          state.wizardData.vehicle.Components.push(item);
        }
      });
    } else {
      // There are no components already, so just use the list from the service.
      state.wizardData.vehicle.Components = data;
      state.wizardData.vehicle.Components.forEach(function (item, index) {
        item.isPresent = true;
      });
    }
    state.wizardData.vehicle.Components.sort(function (a, b) { return a.displayName > b.displayName ? 1 : -1 });
  },
  [types.SET_SAVESTEP1_DATA](state, data) {
    state.wizardData.quote.QuoteID = data.quoteID;
    state.wizardData.customer.CustomerID = data.customerID;
    state.wizardData.quote.CustomerID = data.customerID;
    state.wizardData.vehicle.QuoteID = data.quoteID;
    state.wizardData.callInformation.QuoteID = data.quoteID;
    state.wizardData.callInformation.CallInformationID = data.callInformationID;
    state.wizardData.quotePickupLocation.QuoteID = data.quoteID;
    state.wizardData.thirdParty.QuoteThirdPartyPartnerID = data.quoteThirdPartyPartnerID;
  },
  [types.SET_SAVESTEP2_DATA](state, data) {
    state.wizardData.vehicle.VehicleID = data.vehicleID;
    state.wizardData.offer.VehicleID = data.vehicleID;
    state.wizardData.offer.OfferID = data.offer.offerID;
    state.wizardData.offer.OfferPrice = data.offer.offerPrice;
    state.wizardData.offer.SuggestedPrice = data.offer.suggestedPrice;
    state.wizardData.offer.OfferResponseTypeID = data.offer.offerResponseTypeID;
    state.wizardData.offer.DateCreated = data.offer.dateCreated;
    state.wizardData.previousOffers = data.previousOffers;
  },
  [types.SET_SAVESTEP8_DATA](state, data) {
    state.wizardData.quote_info.stateProofs = data;
  },
  [types.SET_SAVESTEP9_DATA](state, data) {
    state.wizardData.quote_info.pick_up = data;
  },
  [types.SET_FOLLOWUP_QUOTE](state, data) {
    state.wizardData.followup.FollowupID = data;
  },
  [types.SET_SKIP_EXIT_CONFIRMATION](state, data) {
    state.wizardData.skipExitConfirmation = data;
  },
  [types.SET_PARTS_DISPLAY](state, data) {
    state.wizardData.partsDisplay = data;
  },
  [types.SET_SCREEN_POP](state, data) {
    if (data === undefined || data === null) return;
    if (data[0].length <= 0) return;
    data.map(item => {
      if (item.value === null || item.value === undefined) return;
      switch (item.key) {
        case 'First Name': {
          state.wizardData.callInformation.CallerIDName = item.value;
          state.wizardData.mitelCallerID.callerName = item.value;
          return;
        }
        case 'Last Name': {
          state.wizardData.callInformation.CallerIDName = state.wizardData.callInformation.CallerIDName + ' ' + item.value;
          state.wizardData.mitelCallerID.callerName = state.wizardData.mitelCallerID.callerName + ' ' + item.value;
          return;
        }
        case 'Incoming Number': {
          if (item.value === null || item.value === undefined) return;
          state.wizardData.callInformation.CallerIDPhoneID = item.value;
          state.wizardData.mitelCallerID.callerNumber = item.value;
          return;
        }
        case 'Call Code': {
          state.wizardData.callInformation.CallCodeID = item.value;
          state.wizardData.mitelCallerID.callCodeID = item.value;
          return;
        }
        case 'Number Label': {
          state.wizardData.mitelCallerID.callCodeName = item.value;
          return
        }
        case 'Vehicle Make': {
          state.wizardData.vehicle.Make = item.value;
          return;
        }
        case 'Make ID': {
          state.wizardData.vehicle.MakeID = item.value;
          return;
        }
        case 'Vehicle Model': {
          state.wizardData.vehicle.Model = item.value;
          return;
        }
        case 'Model ID': {
          state.wizardData.vehicle.ModelID = item.value;
          return;
        }
        case 'Vehicle Year': {
          state.wizardData.vehicle.ModelYear = item.value;
          return;
        }
        case 'Session Id': {
          state.wizardData.callInformation.VoiceSessionID = item.value;
          return;
        }
      }
    })
  },
  [types.SET_CALL_INFORMATION](state, data) {
    state.wizardData.callInformation.QuoteID = data.quoteID;
    state.wizardData.callInformation.CallerIDName = data.callerIDName;
    state.wizardData.callInformation.CallerIDPhoneID = data.callerIDPhoneID;
    state.wizardData.callInformation.CallCodeID = data.callCodeID;
    state.wizardData.callInformation.CallInformationID = data.callInformationID;
  }
}

export default mutation;



// WEBPACK FOOTER //
// ./src/store/modules/wizard/mutations.js